import { SpinnerComponent } from 'components/spinner';

export function LoadingPage() {
  return (
    <div className="flex flex-col justify-center items-center h-screen mx-2">
      <SpinnerComponent />
      <p className="text-gray-500 text-sm mt-3 mx-12 text-center">
        Please wait while we fetching the data...
      </p>
    </div>
  );
}
